import { CreateChannelForm } from '@/components/shared/components/CreateChannelDialog/components/CreateChannelForm';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const AddChannelForm = () => {
  return <CreateChannelForm fullWidth fieldVariant={FieldVariant.form} />;
};
